import { Card } from '@dreamtree-org/twreact-ui';

/** A titled card section with optional header actions. */
export default function SectionCard({ title, actions, children, className = '' }) {
  return (
    <Card className={`p-4 space-y-3 ${className}`}>
      {title || actions ? (
        <div className="flex flex-wrap items-center justify-between gap-2">
          {title ? <h2 className="font-semibold">{title}</h2> : <span />}
          {actions}
        </div>
      ) : null}
      {children}
    </Card>
  );
}
